<article id="shop-detail">
  <div class="util-contents">
    <app-nav class="nav" [shopInfo]="shopInfo" [option]="option" (changeOption)="setOption($event)"></app-nav>
    <app-memo class="memo" [shopInfo]="shopInfo" (refresh)="onRefresh($event)"></app-memo>
  </div>
  <div class="info-contents">
    <app-shop-info [option]="option" [shopInfo]="shopInfo" (refresh)="onRefresh($event)"></app-shop-info>
  </div>
</article>
